<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useListReleaseNoteApi } from './api/listReleaseNoteApi';
import { type ReleaseNote } from 'shared/releaseNotes/domain/releaseNote';
import ReleaseNoteList from 'shared/releaseNotes/components/ReleaseNoteList.vue';
import { useActionFailedAlert } from 'shared/problems/composables/actionFailedAlert';
import MainLayout from '@/common/components/MainLayout.vue';
import { Card } from 'primevue';

const actionFailedAlert = useActionFailedAlert();
const listReleaseNoteApi = useListReleaseNoteApi();
const notes = ref<ReleaseNote[]>([]);

onMounted(async () => {
  const response = await listReleaseNoteApi.execute();
  if (!response.ok) {
    actionFailedAlert.show(response.details);
    return;
  }
  notes.value = response.notes;
});

</script>

<template>
  <MainLayout>
    <Card class="release-note-card">
      <template #content>
          <ReleaseNoteList v-model:model-value="notes"></ReleaseNoteList>
      </template>
    </Card>
  </MainLayout>

</template>

<style scoped>
.release-note-card {
  height: 100%;
  overflow-y: hidden;
}

:deep(.p-card-body) {
  overflow-y: hidden;
}

:deep(.p-card-content) {
  overflow-y: hidden;
}
</style>
